// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e0eb14ff","814":"af708ce1","875":"87cbc2cb"}[chunkId] + ".chunk.js";
};